import { EmptystateShareColored } from "components/icons/generated";
import ListContentWrapper from "components/ListContentWrapper";
import EmptyState from "ds/components/EmptyState";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";

const SpaceDetailsIdpGroupsLoginPolicyEmptyState = () => (
  <>
    <PageInfoHeaderWrapper>
      <PageInfoHeaderTitle title="IdP Groups" />
    </PageInfoHeaderWrapper>

    <ListContentWrapper>
      <EmptyState
        title="IdP groups aren't listed per space"
        icon={EmptystateShareColored}
        caption="With login policies, group membership is resolved when someone logs in and folded into their session, so there's no per-space group list. The Users tab shows who currently holds access."
      />
    </ListContentWrapper>
  </>
);

export default SpaceDetailsIdpGroupsLoginPolicyEmptyState;
